import { FC, PropsWithChildren } from 'react';
import { BodyText } from '@servicetitan/design-system';

export const LabelText: FC<PropsWithChildren> = ({ children }) => (
    <BodyText bold size="small">
        {`${children}:`}
    </BodyText>
);

export const FieldText: FC<PropsWithChildren> = ({ children }) => (
    <BodyText size="small">{children}</BodyText>
);
